// Nails Studio Data
// Options for nail shape, length, color, and finish

/**
 * Nail Shapes
 */
export const nailShapes = [
  { id: 'square', name: 'Square', promptText: 'square shape' },
  { id: 'round', name: 'Round', promptText: 'round shape' },
  { id: 'almond', name: 'Almond', promptText: 'almond shape' },
  { id: 'coffin', name: 'Coffin', promptText: 'coffin shape' },
  { id: 'stiletto', name: 'Stiletto', promptText: 'stiletto shape' },
];

/**
 * Nail Lengths
 */
export const nailLengths = [
  { id: 'short', name: 'Short', promptText: 'short length' },
  { id: 'medium', name: 'Medium', promptText: 'medium length' },
  { id: 'long', name: 'Long', promptText: 'long length' },
];

/**
 * Nail Colors
 * Visual color cards (like hair color)
 */
export const nailColors = [
  {
    id: 'natural',
    name: 'Natural',
    displayName: 'Natural',
    colorHex: '#F5D5C8',
    promptText: 'natural nude color'
  },
  {
    id: 'french-white',
    name: 'French White',
    displayName: 'French',
    colorHex: '#FFFFFF',
    promptText: 'classic French white tips'
  },
  {
    id: 'soft-pink',
    name: 'Soft Pink',
    displayName: 'Soft Pink',
    colorHex: '#FFB6C1',
    promptText: 'soft pink color'
  },
  {
    id: 'red',
    name: 'Red',
    displayName: 'Red',
    colorHex: '#DC143C',
    promptText: 'bold red color'
  },
  {
    id: 'burgundy',
    name: 'Burgundy',
    displayName: 'Burgundy',
    colorHex: '#800020',
    promptText: 'deep burgundy color'
  },
  {
    id: 'coral',
    name: 'Coral',
    displayName: 'Coral',
    colorHex: '#FF7F50',
    promptText: 'coral color'
  },
  {
    id: 'lavender',
    name: 'Lavender',
    displayName: 'Lavender',
    colorHex: '#E6E6FA',
    promptText: 'lavender color'
  },
  {
    id: 'black',
    name: 'Black',
    displayName: 'Black',
    colorHex: '#1C1C1C',
    promptText: 'black color'
  },
  {
    id: 'navy',
    name: 'Navy',
    displayName: 'Navy',
    colorHex: '#000080',
    promptText: 'navy blue color'
  },
  {
    id: 'mint',
    name: 'Mint',
    displayName: 'Mint',
    colorHex: '#98FF98',
    promptText: 'mint green color'
  },
  {
    id: 'gold',
    name: 'Gold',
    displayName: 'Gold',
    colorHex: '#FFD700',
    promptText: 'gold metallic color'
  },
  {
    id: 'silver',
    name: 'Silver',
    displayName: 'Silver',
    colorHex: '#C0C0C0',
    promptText: 'silver metallic color'
  },
];

/**
 * Nail Finishes / Looks
 */
export const nailFinishes = [
  { id: 'glossy', name: 'Glossy', promptText: 'glossy finish' },
  { id: 'matte', name: 'Matte', promptText: 'matte finish' },
  { id: 'chrome', name: 'Chrome', promptText: 'chrome metallic finish' },
  { id: 'french', name: 'French', promptText: 'French manicure style' },
  { id: 'minimal-art', name: 'Minimal Art', promptText: 'minimal nail art accents' },
];

/**
 * Get nail shape by ID
 */
export const getNailShapeById = (id) => {
  return nailShapes.find(shape => shape.id === id);
};

/**
 * Get nail length by ID
 */
export const getNailLengthById = (id) => {
  return nailLengths.find(length => length.id === id);
};

/**
 * Get nail color by ID
 */
export const getNailColorById = (id) => {
  return nailColors.find(color => color.id === id);
};

/**
 * Get nail finish by ID
 */
export const getNailFinishById = (id) => {
  return nailFinishes.find(finish => finish.id === id);
};
